import { useState, useEffect, useCallback, memo } from "react";
import { Link } from "react-router-dom";
import AnimacionCarga from "./animacion_de_carga";
import BarraSuperior from "./barra_superior";
import BotonSOS from "./sos/boton_sos";
import { consultarSimple } from "../../functions/crud";
import { CONFIG } from "../../functions/variables_globales";
import "bootstrap-icons/font/bootstrap-icons.css";


const DIAS = [
  { clave: "lunes",   etiqueta: "Lunes",     estado: "lunesEstado",     desde: "horaInicioAtencion", hasta: "horaFinalAtencion" },
  { clave: "martes",  etiqueta: "Martes",    estado: "martesEstado",    desde: "martesDesde",        hasta: "martesHasta" },
  { clave: "miercoles", etiqueta: "Miércoles", estado: "miercolesEstado", desde: "miercolesDesde",   hasta: "miercolesHasta" },
  { clave: "jueves",  etiqueta: "Jueves",    estado: "juevesEstado",    desde: "juevesDesde",        hasta: "juevesHasta" },
  { clave: "viernes", etiqueta: "Viernes",   estado: "viernesEstado",   desde: "viernesDesde",       hasta: "viernesHasta" },
  { clave: "sabado",  etiqueta: "Sábado",    estado: "sabadoEstado",    desde: "sabadoDesde",        hasta: "sabadoHasta" },
  { clave: "domingo", etiqueta: "Domingo",   estado: "domingoEstado",   desde: "domingoDesde",       hasta: "domingoHasta" },
  { clave: "festivo", etiqueta: "Festivo",   estado: "festivoEstado",   desde: "festivoDesde",       hasta: "festivoHasta" },
];

const indiceDiaHoy = () => {
  const dia = new Date().getDay();
  return dia === 0 ? 6 : dia - 1;
};

const esVerdadero = (valor) => valor === true || valor === "true" || valor === "Sí" || valor === "SI";

const cargarCliente = async () => {
  const nit = CONFIG.codigoCliente();
  if (!nit) return {};

  const id = await consultarSimple(`/clientes/${nit}`);
  if (!id || typeof id === "object") return {};

  return await consultarSimple(`/coordi_ph_clientes/${nit}/${id}`);
};

const enlaceWhatsapp = (valor) => {
  const nombre = localStorage.getItem("NombreCompleto") || "";
  const residencia = localStorage.getItem("Direccion") || "";
  const mensaje = encodeURIComponent(`Buen día, soy ${nombre} - ${residencia}.`);
  return `https://wa.me/+57${String(valor).replace(/\D/g, "")}?text=${mensaje}`;
};


const Dato = ({ etiqueta, valor, ancho }) => {
  if (!valor || valor === "null") return null;

  return (
    <div style={{ ...s.campo, ...(ancho ? s.campoAncho : {}) }}>
      <span style={s.etiqueta}>{etiqueta}</span>
      <div style={s.valor} title={valor}>{valor}</div>
    </div>
  );
};

const Contacto = ({ etiqueta, valor }) => {
  if (!valor || valor === "null") return null;

  return (
    <div style={s.campo}>
      <span style={s.etiqueta}>{etiqueta}</span>
      <a
        style={{ ...s.valor, ...s.valorEnlace }}
        href={enlaceWhatsapp(valor)}
        target="_blank"
        rel="noopener noreferrer"
        title={`Escribir por WhatsApp a ${valor}`}
      >
        <span>{valor}</span>
        <i className="bi bi-whatsapp" style={s.iconoWhatsapp} />
      </a>
    </div>
  );
};

const FilaHorario = ({ dia, cliente, esHoy }) => {
  const abierto = esVerdadero(cliente[dia.estado]);

  return (
    <div style={s.horarioFila}>
      <span style={{ ...s.horarioDia, ...(abierto ? {} : s.horarioApagado), ...(esHoy ? s.horarioDiaHoy : {}) }}>
        {dia.etiqueta}
        {esHoy && <span style={s.etiquetaHoy}>HOY</span>}
      </span>

      {abierto ? (
        <span style={{ ...s.horarioRango, ...(esHoy ? s.horarioRangoHoy : {}) }}>
          {cliente[dia.desde] || "--:--"}
          <span style={s.horarioSep}>–</span>
          {cliente[dia.hasta] || "--:--"}
        </span>
      ) : (
        <span style={s.horarioCerrado}>Sin atención</span>
      )}
    </div>
  );
};


const MiPropiedad = memo(() => {
  const [cliente, setCliente] = useState({});
  const [cargando, setCargando] = useState(true);

  const capturarDatos = useCallback(async () => {
    setCargando(true);
    try {
      setCliente(await cargarCliente());
    } catch (error) {
      console.error("Error al cargar la copropiedad:", error);
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => { capturarDatos(); }, [capturarDatos]);

  if (cargando) return <AnimacionCarga />;

  const hoy = indiceDiaHoy();
  const tieneHorarios = DIAS.some((d) => esVerdadero(cliente[d.estado]));
  const logo = cliente.logo && cliente.logo !== "null" ? cliente.logo : "";
  const razonSocial = cliente.Nombre || CONFIG.razonSocial() || "Mi propiedad";
  const diaHoy = DIAS[hoy];
  const abiertoHoy = esVerdadero(cliente[diaHoy.estado]);

  return (
    <div style={s.page}>
      <BarraSuperior />

      <div style={s.contenedor}>
        <header style={s.header}>
          <div style={s.headerTexto}>
            <h1 style={s.headerTitle}>{razonSocial}</h1>
            <p style={s.headerSub}>
              NIT {cliente.Nit || CONFIG.codigoCliente()}
              {tieneHorarios && (
                <>
                  {" · "}
                  <span style={abiertoHoy ? s.chipAbierto : s.chipCerrado}>
                    {abiertoHoy
                      ? `Hoy ${cliente[diaHoy.desde] || "--:--"} a ${cliente[diaHoy.hasta] || "--:--"}`
                      : "Hoy sin atención"}
                  </span>
                </>
              )}
            </p>
          </div>

          <div style={s.headerAcciones}>
            <Link to="/documentos" style={s.botonPrimario}>
              <i className="bi bi-file-earmark-text" style={{ marginRight: 8 }} />
              Ir a documentos
            </Link>
            <button type="button" style={s.botonIcono} onClick={capturarDatos} title="Refrescar">
              <i className="bi bi-arrow-clockwise" />
            </button>
          </div>
        </header>

        <div style={s.tarjetas}>
          <section style={s.tarjeta}>
            <h2 style={s.seccionTitulo}>Información de la copropiedad</h2>

            <div style={s.grupoCampos}>
              <div style={s.logoCaja}>
                {logo ? (
                  <img src={logo} alt="Logo de la copropiedad" style={s.logoImg} />
                ) : (
                  <i className="bi bi-building" style={{ fontSize: 26, color: "#9ca3af" }} />
                )}
              </div>

              <Dato etiqueta="Mi dirección"                valor={localStorage.getItem("Direccion")} />
              <Dato etiqueta="Dirección de la copropiedad" valor={cliente.Direccion} />
              <Dato etiqueta="Administrador"               valor={cliente.NombreAdministrador} />
              <Dato etiqueta="Correo electrónico"          valor={cliente.correoElectronico || cliente.CorreoAdministrador} ancho />
              <Contacto etiqueta="Teléfono administración" valor={cliente.TelefonoAdministrador} />
              <Contacto etiqueta="Teléfono portería"       valor={cliente.telefonoPorteria} />
            </div>
          </section>

          {tieneHorarios && (
            <section style={s.tarjeta}>
              <h2 style={s.seccionTitulo}>Horario de atención</h2>

              <div style={s.horarios}>
                {DIAS.map((dia, indice) => (
                  <FilaHorario key={dia.clave} dia={dia} cliente={cliente} esHoy={indice === hoy} />
                ))}
              </div>
            </section>
          )}
        </div>
      </div>

      <BotonSOS />
    </div>
  );
});

const s = {
  page: {
    minHeight: "100vh",
    background: "#f8f9fb",
    fontFamily: "'DM Sans', 'Segoe UI', system-ui, sans-serif",
    paddingBottom: 100,
  },
  contenedor: { width: "100%", maxWidth: 1600, margin: "0 auto", padding: "0 32px", boxSizing: "border-box" },
  header: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 16,
    padding: "28px 0 20px",
    borderBottom: "1px solid #e5e7eb",
    marginBottom: 24,
    minWidth: 0,
  },
  headerTexto: { minWidth: 0, flex: "1 1 320px" },
  headerTitle: { margin: 0, fontSize: 22, fontWeight: 700, color: "#1a1a2e", lineHeight: 1.25 },
  headerSub: { margin: "6px 0 0", fontSize: 13.5, color: "#6b7280" },
  chipAbierto: { color: "#047857", fontWeight: 600 },
  chipCerrado: { color: "#9ca3af", fontWeight: 600 },
  headerAcciones: { display: "flex", alignItems: "center", gap: 12, flexShrink: 0 },
  botonPrimario: {
    display: "inline-flex",
    alignItems: "center",
    padding: "11px 24px",
    borderRadius: 10,
    background: "#c0392b",
    color: "#ffffff",
    fontSize: 14.5,
    fontWeight: 600,
    textDecoration: "none",
    whiteSpace: "nowrap",
  },
  botonIcono: {
    width: 42,
    height: 42,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    border: "1px solid #d1d5db",
    background: "#ffffff",
    color: "#6b7280",
    fontSize: 16,
    cursor: "pointer",
  },
  tarjetas: { display: "flex", flexDirection: "column", gap: 24 },
  tarjeta: {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    padding: "22px 24px 8px",
    boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
  },
  seccionTitulo: {
    fontSize: 15,
    fontWeight: 700,
    color: "#1a1a2e",
    margin: "0 0 18px",
    textTransform: "uppercase",
    letterSpacing: 0.6,
  },
  grupoCampos: { display: "flex", flexWrap: "wrap", alignItems: "flex-start", gap: 18 },
  campo: { flex: "1 1 240px", minWidth: 0, marginBottom: 16 },
  campoAncho: { flex: "1 1 100%" },
  etiqueta: {
    display: "block",
    marginBottom: 6,
    color: "#6b7280",
    fontSize: 13,
    fontWeight: 500,
  },
  valor: {
    width: "100%",
    padding: "11px 13px",
    border: "1px solid #d1d5db",
    borderRadius: 8,
    fontSize: 14,
    color: "#1a1a2e",
    background: "#ffffff",
    boxSizing: "border-box",
    overflowWrap: "anywhere",
  },
  valorEnlace: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    textDecoration: "none",
    cursor: "pointer",
  },
  iconoWhatsapp: { flexShrink: 0, fontSize: 16, color: "#25d366" },
  logoCaja: {
    flex: "0 0 auto",
    width: 62,
    height: 62,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 22,
    marginBottom: 16,
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    background: "#ffffff",
  },
  logoImg: { width: "100%", height: "100%", padding: 7, borderRadius: 12, objectFit: "contain", boxSizing: "border-box" },
  horarios: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    columnGap: 32,
    marginBottom: 14,
  },
  horarioFila: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    padding: "11px 0",
    borderBottom: "1px solid #f0f1f4",
  },
  horarioDia: {
    display: "inline-flex",
    alignItems: "center",
    gap: 9,
    fontSize: 14,
    color: "#1a1a2e",
  },
  horarioDiaHoy: { fontWeight: 700 },
  horarioApagado: { color: "#b0b0b6" },
  etiquetaHoy: {
    padding: "2px 8px",
    borderRadius: 999,
    background: "#1a1a2e",
    color: "#ffffff",
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: 0.4,
  },
  horarioRango: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    flexShrink: 0,
    fontSize: 14,
    color: "#48484a",
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
  },
  horarioRangoHoy: { fontWeight: 700, color: "#1a1a2e" },
  horarioSep: { color: "#c7c7cc" },
  horarioCerrado: { flexShrink: 0, fontSize: 13.5, color: "#c7c7cc" },
};

export default MiPropiedad;
